<template lang="pug">
  .card
    .card-body
      .row(v-if="$router.user.roleScore >= 2")
        .col-md-6
        .col-md-6
          .form-check
            input.mr-2(id="simulate3" type="checkbox" v-model="simulateError")
            label.text-danger Simulate Checkup Error
          .form-check
            input.mr-2(id="downgrade3" type="checkbox" v-model="downgradeFirmware")
            label.text-danger Downgrade Firmware
      .row
        .col-12.col-md-6
          .card.card--device(:style="`border-left: 6px solid ${color};`")
            .card-body
              .d-flex.align-items-center.justify-content-between
                .d-flex.align-items-center.gap-2
                  h6.mb-0.card-title Dispositivo
                  span.badge.badge-info(v-if="testCount > 0") {{ testCount }} test
                button.btn.btn-sm.btn-primary(v-if="isSupported" @click="startTestPipeline" :disabled="isTesting") Inizia Collaudo
                .text.text-danger(v-else) Bluetooth is not supported on this device/browser.
              table.table.mt-2(v-if="bleDevice || isTesting")
                tr
                  td Nome
                  td {{ deviceInfo.name }}
                tr
                  td Firmware
                  td
                    span {{ deviceInfo.firmware.version }}
                    span(v-if="deviceInfo.firmware.latest") (Ultima: {{ deviceInfo.firmware.latest }})
                tr
                  td  Check Up
                  td
                    span.badge.mx-1(
                      v-for="(value, key) in deviceInfo.checkup"
                      :class="value ? 'badge-success' : 'badge-danger'"
                      :title="legend[key]"
                    ) {{ key }}
                tr
                  td Batteria
                  td
                    span.badge.mx-1(v-if="deviceInfo.battery.percentage !== ''" :class="deviceInfo.battery.percentage < 30 || deviceInfo.battery.percentage > 50 ? 'badge-warning' : 'badge-success'") {{ deviceInfo.battery.percentage }}%
                    span.mx-1 -
                    span(v-if="deviceInfo.battery.voltage") {{ deviceInfo.battery.voltage }} mV
                tr
                  td Shipping Mode
                  td
                    span.badge(:class="deviceInfo.shipping_mode === null ? 'badge-secondary' : deviceInfo.shipping_mode ? 'badge-success' : 'badge-secondary'") {{ deviceInfo.shipping_mode === null ? '' : deviceInfo.shipping_mode ? 'Activated' : 'Not Activated' }}
              .alert.alert-danger(v-if="errorMessage") {{ errorMessage }}
              button.btn.btn-sm.btn-danger(v-if="isTesting" @click="resetTest" :disabled="!isTesting")
                i.fa.fa-stop-circle.mr-2
                span Arresta Collaudo
        .col-12.col-md-6
          .steps
            .step(v-for="(step, index) in steps" :class="step.status")
              .d-flex.align-items-center
                .step__status
                  template(v-if="step.status === 'to-do'") {{ index + 1 }}
                  i.fa.fa-spinner.spinner(v-if="step.status === 'in-progress'")
                  i.fa.fa-check(v-if="step.status === 'passed'")
                  i.fa.fa-times(v-if="step.status === 'failed'")
                  i.fa.fa-forward(v-if="step.status === 'skipped'")
                div
                  .step__name {{ step.name }}
                  small.step__description {{ step.description }}
              .step_substeps(v-if="step.substeps")
                .step.substep.d-flex(v-for="(substep, i) in step.substeps" :class="substep.status" v-if="substep.status !== 'to-do'")
                  .step__status
                    template(v-if="substep.status === 'to-do'") {{ index + 1 }}.{{ i + 1 }}
                    i.fa.fa-spinner.spinner(v-if="substep.status === 'in-progress'")
                    i.fa.fa-check(v-if="substep.status === 'passed'")
                    i.fa.fa-times(v-if="substep.status === 'failed'")
                    i.fa.fa-forward(v-if="substep.status === 'skipped'")
                  .step__name {{ substep.name }}
          .mt-1(v-if="isTestCompleted || isTestFailed")
            button.btn-block.btn.btn-success.mb-1(:disabled="isSaving" @click="endTest(false)") Tutto ok
</template>
<script>

import { BleService, DeviceType, ShelfyWifiConnectionMode, ShelfyWifiSecurityMethod } from "@vitesy/vhub-browser-ble"
import ProductionService from "@/services/ProductionService"

const CONFIG = {
  WiFiCredentials: {
    SSID: 'MW40V_DA06',
    Password: '98541014',
    SecurityMethod: ShelfyWifiSecurityMethod.WPA_PSK,
  }
}

const COLORS = {
  red:    [0xFF, 0x00, 0x00],
  green:  [0x00, 0xFF, 0x00],
  blue:   [0x00, 0x00, 0xFF],
  purple: [0xFF, 0x00, 0xFF],
  yellow: [0xFF, 0xFF, 0x00],
  orange: [0xFF, 0xA5, 0x00],
  cyan:   [0x00, 0xFF, 0xFF],
}

const STATUS = {
  TO_DO:       "to-do",
  IN_PROGRESS: "in-progress",
  PASSED:      "passed",
  FAILED:      "failed",
  SKIPPED:     "skipped",
}

export default {
  name: 'SingleDeviceTesting3',
  props: ['color'],
  data() {
    return {
      testCount: 0,
      order: null,
      simulateError: false,
      downgradeFirmware: false,
      isSupported: false,
      isTesting: false,
      isTestCompleted: false,
      isTestFailed: false,
      isSaving: false,
      bleDevice: null,
      deviceInfo: {},
      failedTestReasonId: null,
      errorMessage: null,
      keyHandler: null,
      steps: [
        { name: 'Connessione al Dispositivo', status: STATUS.TO_DO },
        {
          name: 'Controllo Versione Firmware',
          status: STATUS.TO_DO,
          substeps: [
            { name: 'Connessione al Wi-Fi',   status: STATUS.TO_DO },
            { name: 'Aggiornamento Firmware', status: STATUS.TO_DO },
          ]
        },
        { name: 'Check Up Automatico', status: STATUS.TO_DO },
        {
          name: 'Controllo Manuale',
          description: 'Percentuale carica batteria, led e ventola accesi, difetti estetici.',
          status: STATUS.TO_DO
        },
        { name: 'Impostazione Shipping Mode',  status: STATUS.TO_DO },
        { name: 'Disconnessione dal Dispositivo', status: STATUS.TO_DO },
        { name: 'Collaudo Completato',         status: STATUS.TO_DO },
      ],
      legend: {
        CHG:     "Battery Charger",
        SHT4x:   "Sensore Temperatura/Umidità",
        LIS2DH12:"Accelerometro",
        LPS22HH: "Sensore Pressione/Temperatura",
        BME680:  "Sensore Gas",
      }
    }
  },
  methods: {
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    compareVersions(a, b) {
      const ap = a.split('.').map(Number)
      const bp = b.split('.').map(Number)
      ap.push(0, 0, 0)
      bp.push(0, 0, 0)
      for (let i = 0; i < 3; i++) {
        if (ap[i] < bp[i]) return 1
        if (ap[i] > bp[i]) return -1
      }
      return 0
    },
    sendError(msg) {
      throw new Error(msg)
    },

    async resetTest() {
      if (this.bleDevice) {
        try { await this.bleDevice.disconnect() } catch {}
        this.bleDevice = null
      }
      this.isTesting        = false
      this.isTestCompleted  = false
      this.isTestFailed     = false
      this.errorMessage     = null
      this.steps.forEach(step => {
        step.status = STATUS.TO_DO
        step.substeps?.forEach(s => { s.status = STATUS.TO_DO })
      })
      this.deviceInfo = {
        name: '',
        mac: '',
        firmware: { version: '-', latest: null, updated: false },
        battery:  { percentage: '', voltage: '' },
        leds:     { output: null, internal: null },
        fan:      null,
        checkup:  {},
        shipping_mode: null,
        start_timestamp: null,
      }
    },

    async connectToDevice() {
      this.steps[0].status = STATUS.IN_PROGRESS
      try {
        const device = await BleService.requestDevice([DeviceType.SHELFY, DeviceType.SHELFY_R1])
        await device.connect()
        // Give firmware time to stabilise after BLE connection before sending first command
        await this.wait(600)
        this.bleDevice = device
        this.deviceInfo.name = device.name
        this.deviceInfo.mac  = device.id.replace(/:/g, '')
        this.steps[0].status = STATUS.PASSED
      } catch (error) {
        this.steps[0].status = STATUS.FAILED
        throw error
      }
    },

    async checkFirmwareVersion() {
      this.steps[1].status = STATUS.IN_PROGRESS
      const firmwareVersion = await this.bleDevice.getFirmwareVersion()
      this.deviceInfo.firmware.version = firmwareVersion

      if (!firmwareVersion) {
        this.steps[1].status = STATUS.FAILED
        this.failedTestReasonId = [2.1]
        this.sendError('Unable to Read Firmware!')
      }

      const latestFirmwareVersion = (
        this.order?.id_number === 'P0000806' ||
        this.order?.id_number === 'P0000807' ||
        this.order?.id_number === 'P0000808'
      ) ? '1.1.1' : '1.2.0'
      this.deviceInfo.firmware.latest = latestFirmwareVersion

      const needsUpdate = this.compareVersions(firmwareVersion, latestFirmwareVersion) > 0
      if (needsUpdate) {
        this.deviceInfo.firmware.updated = true
        this.steps[1].substeps[0].status = STATUS.IN_PROGRESS

        await this.bleDevice.setWifiSsid(CONFIG.WiFiCredentials.SSID)
        await this.bleDevice.setWifiPsw(CONFIG.WiFiCredentials.Password)
        await this.bleDevice.setWifiConnect(ShelfyWifiConnectionMode.AUTO, CONFIG.WiFiCredentials.SecurityMethod)

        let wifiOk = false
        for (let i = 0; i < 10 && !wifiOk; i++) {
          await this.wait(3000)
          wifiOk = await this.bleDevice.isWifiConnected()
        }
        if (!wifiOk) {
          this.steps[1].status = STATUS.FAILED
          this.steps[1].substeps[0].status = STATUS.FAILED
          this.steps[1].substeps[1].status = STATUS.FAILED
          this.failedTestReasonId = [2.1]
          this.sendError('Unable to Connect to Wi-Fi to Update Firmware!')
        }

        this.steps[1].substeps[0].status = STATUS.PASSED
        this.steps[1].substeps[1].status = STATUS.IN_PROGRESS
        await this.bleDevice.setOTA(latestFirmwareVersion)
        await this.wait(5000)
        await this.checkFirmwareVersion()
      } else {
        if (this.deviceInfo.firmware.updated) this.steps[1].substeps[1].status = STATUS.PASSED
        this.steps[1].status = firmwareVersion ? STATUS.PASSED : STATUS.FAILED
        this.failedTestReasonId = !firmwareVersion ? [2.1] : null
      }
    },

    async checkup() {
      this.steps[2].status = STATUS.IN_PROGRESS
      const result = await this.bleDevice.getCheckUp()

      this.deviceInfo.checkup.CHG     = result.CHG
      this.deviceInfo.checkup.LPS22HH = result.LPS22HH

      let checkupResult = result.CHG && result.LPS22HH
      if (this.simulateError) checkupResult = false

      this.steps[2].status = checkupResult ? STATUS.PASSED : STATUS.FAILED
      this.deviceInfo.checkup.result = checkupResult

      if (!checkupResult) {
        this.failedTestReasonId = [4.0]
        this.sendError('Checkup failed!')
      } else {
        this.failedTestReasonId = null
      }
    },

    async checkComponents() {
      this.steps[3].status = STATUS.IN_PROGRESS
      console.log('[SDT3] getBatteryPercent...')
      this.deviceInfo.battery.percentage = await this.bleDevice.getBatteryPercent()
      console.log('[SDT3] getBatteryPercent ok:', this.deviceInfo.battery.percentage)
      this.deviceInfo.battery.voltage    = await this.bleDevice.getBatteryVoltage()
      console.log('[SDT3] getBatteryVoltage ok:', this.deviceInfo.battery.voltage)
      await this.bleDevice.setLedIn(5)
      console.log('[SDT3] setLedIn ok')
      await this.bleDevice.setFan(100)
      console.log('[SDT3] setFan ok')
    },

    async startTestPipeline() {
      await this.resetTest()
      this.isTesting = true
      try {
        await this.connectToDevice()
        if (!this.bleDevice) { await this.resetTest(); return }

        try {
          const response = await ProductionService.getProductionOrderByMac(this.deviceInfo.mac)
          this.order = response?.data ?? null
        } catch {
          this.order = null
        }

        this.deviceInfo.start_timestamp = Date.now()

        const startColor = [...COLORS[this.color], ...COLORS[this.color], ...COLORS[this.color], ...COLORS[this.color]]
        await this.bleDevice.setLedOut(...startColor)
        await this.checkFirmwareVersion()
        await this.checkup()
        const greenColor = [...COLORS.green, ...COLORS.green, ...COLORS.green, ...COLORS.green]
        await this.bleDevice.setLedOut(...greenColor)
        await this.checkComponents()
        this.isTestCompleted = true
      } catch (error) {
        this.errorMessage = error
        console.error('PIPELINE ERROR:', error)
        try {
          const redColor = [...COLORS.red, ...COLORS.red, ...COLORS.red, ...COLORS.red]
          await this.bleDevice?.setLedOut(...redColor)
        } catch {}
        this.isTestFailed  = true
        this.isTestCompleted = true
      }
    },

    async endTest(reportedNC) {
      if (reportedNC?.error) {
        alert(`Errore durante segnalazione della non conformità: ${reportedNC.error}`)
      }

      this.isSaving = true
      this.steps[3].status = this.isTestFailed ? STATUS.SKIPPED : !reportedNC ? STATUS.PASSED : STATUS.FAILED

      // Turn off leds/fan, then wait before ship mode to avoid I2C timing issues on SGM41542
      try { await this.bleDevice.setLedIn(0) } catch {}
      try { await this.bleDevice.setFan(0)   } catch {}
      await this.wait(800)

      // Ship mode — device will disconnect BLE after receiving this command
      this.steps[4].status = STATUS.IN_PROGRESS
      try {
        await this.bleDevice.setShippingMode()
      } catch {
        // Expected: BLE drops when device enters low-power ship mode
      }
      this.deviceInfo.shipping_mode = true
      this.steps[4].status = STATUS.PASSED

      // Wait for device to complete the SGM41542 I2C ship mode sequence before
      // sending any BLE event (including gattServer.disconnect terminate request)
      await this.wait(800)

      // Disconnect — library uses gattServer.disconnect() only, no stopNotifications
      this.steps[5].status = STATUS.IN_PROGRESS
      try { await this.bleDevice.disconnect() } catch {}
      this.bleDevice = null
      this.steps[5].status = STATUS.PASSED
      this.steps[6].status = STATUS.PASSED
      this.testCount++

      await this.wait(1000)
      this.isSaving = false
      await this.resetTest()
    },
  },

  async mounted() {
    if ('bluetooth' in navigator) {
      this.isSupported = true
      this.keyHandler = (e) => {
        if (e.keyCode === 32 && !this.isTesting) this.startTestPipeline()
      }
      window.addEventListener('keyup', this.keyHandler)
    } else {
      console.error('Bluetooth is not supported on this device/browser.')
    }
  },

  async beforeUnmount() {
    if (this.keyHandler) window.removeEventListener('keyup', this.keyHandler)
    await this.resetTest()
  },
}
</script>
<style lang="scss" scoped>
@import "../../styles/variables.scss";
.code {
  background-color: #2c2c2c;
  color: #B4D455;
}

.steps {
  position: relative;
  &:before {
    content: '';
    display: block;
    width: 2px;
    height: 100%;
    position: absolute;
    left: 1.25rem;
    top: 0;
    background-color: $lightblue;
  }
}
.step, .substep {
  position: relative;
  background-color: #fff;
  border: 1px solid $lightblue;
  border-radius: 2rem;
  padding: .25rem .25rem;
  margin: .5rem 0;
  align-items: center;

  &__description {
    line-height: 0;
  }

  &__status {
    background-color: $lightblue;
    width: 2rem;
    height: 2rem;
    border-radius: 100%;
    text-align: center;
    font-size: 1rem;
    line-height: 2rem;
    margin-right: .5rem;
    flex: 0 0 auto;
  }
  &.passed {
    .step__status {
      background-color: $green!important;
      animation: none!important;
      color: #fff;
    }
    border-color: $green;
  }
  &.failed {
    .step__status {
      background-color: $red;
      color: #fff;
    }
    border-color: $red;
  }
  &.skipped {
    .step__status {
      background-color: $gray01;
      color: $gray02;
    }
    border-color: $gray02;
  }
  &.to-do {
    opacity: .75;
  }
  &.in-progress {
    .step__status {
      @extend .rotate;
      background-color: $blue;
      color: #fff;
    }
    border-color: $blue;
  }
}
</style>
